/* eslint-disable @typescript-eslint/naming-convention */
import React, { FunctionComponent } from 'react';
import { Grid } from '@mui/material';
import ResourcesGroup from './ResourcesGroup';
import styles from './ResourcesDashboard.styles';
import resourcesGroups from './resources';
import useStyles from './ResourcesDashboard.styles';

const ResourcesDashboard: FunctionComponent = () => {

  const classes = useStyles();
  return (
    <Grid container spacing={2} className={classes.root}>
      {
        resourcesGroups && resourcesGroups.length && resourcesGroups.map((resourcesGroup, index) =>
          <Grid 
            size = {{xs: 12, sm:6}}
            key={`${resourcesGroup.header}_${index}`}
            className={classes.resourceGroup}>
            {
              <ResourcesGroup resourcesGroup={resourcesGroup} />
            }
          </Grid>
        )
      }
    </Grid>
  );
};

export default ResourcesDashboard;

